<template>
  <!-- 头部整体盒子 -->
  <div id="header">
    <!-- 头部顶部 -->
    <!--    <div class="header-top container-fuild hidden-xs">-->
    <!--      <div class="container">-->
    <!--        <div class="server pull-left animate__animated animate__fadeInDownBig">-->
    <!--          <span class="glyphicon glyphicon-earphone"></span>888-888-888-->
    <!--          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com-->
    <!--          <span class="glyphicon glyphicon-time "></span>7x24小时为您服务-->
    <!--        </div>-->
    <!--        <div class="shejiao pull-right">-->
    <!--          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！-->
    <!--          <span class="glyphicon glyphicon-hand-left"></span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!-- 电脑导航 -->
    <div class="header-nav  hidden-xs ">
      <!-- 导航logo -->
      <div class="header-nav-logo animate__animated animate__slideInDown">
        <img src="@/assets/img/logo-bl.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper animate__animated animate__slideInDown">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length>0||(menuList.length>0 && item.name =='AI智能监测系统')"
                  :style="{transform:index==navIndex?'rotate(180deg)':''}"
                  class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0 && item.name !='AI智能监测系统'"
          >
            <dt v-for="(i,n) in item.children" :key="n" @click="openUrl(i,n)">
              <img src="../assets/img/home/xuanzhong.png" style="width: 20px;height: 20px">
              <div style="font-size: 16px">{{ i.name }}</div>
            </dt>
          </dl>
          <dl v-if="menuList.length>0 && item.name =='AI智能监测系统'"
          >
            <dt v-for="(i,n) in menuList" :key="n"
                @click="Onclick(i,n)">
              <img src="../assets/img/home/xuanzhong.png" style="width: 20px;height: 20px">
              <div style="font-size: 16px">{{ i.twosystemName }}</div>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img alt="logo" class="center-block" src="@/assets/img/logo_black.png">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-target="#menu"
          data-toggle="collapse"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            data-target="#menu"
            data-toggle="collapse"
            @click="navClick(index,item.name)"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import 'animate.css'
import {listMonitorTable} from "@/api/monitorTable";
import {scrollToTop} from "@/unitls/scrollUtils";

export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      menuList: [],
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "AI智能产品",
          path: "/service",
          children: []
        },
        {
          name: "AI智能监测系统",
          path: "/AiZhi",
          children: []
        },
        {
          name: "安全监测平台",
          path: "/software",
          children: [
            {
              name: "风力发电综合智能安全监测平台",
              path: "/software/smartTown"
            },
            {
              name: "中央监控系统",
              path: "/software/bigData"
            }
          ]
        },
        {
          name: "公司介绍",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "新闻资讯",
          path: "/newsinformation",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ],
      isxuanzhong: true,
      activeIndex: 0,
      ziIndex: 0
    };
  },
  mounted() {
    this.getList()
    this.setNavIndex()
  },
  computed: {
    activexitong() {
      console.log(this.$store.getters.activexitong, "ewqeq")
      return this.$store.getters.activexitong;
    }
  },

  watch: {
    // 监听路由对象本身的变化
    '$route'(to, from) {
      window.scrollTo(0, 0)
      this.setNavIndex()
      let iscaidan = false
      if (to.path == '/software/bigData' || to.path == '/software/smartTown') {
        iscaidan = true
      } else {
        iscaidan = false
      }
      if (to.path == '/software/smartTown') {
        this.ziIndex = 0
      }
      if (to.path == '/software/bigData') {
        this.ziIndex = 1
      }
      if (to.path == '/AiZhi' && this.menuList.length > 0 && this.activeIndex == this.menuList[0].monitorId) {
        this.Onclick(this.menuList[0], this.menuList[0].monitorId)
      }
      if (this.ziIndex == 1 && iscaidan) {
        this.openUrl({path: '/software/bigData'}, 1)
      }

      // 你可以在这里根据路由变化执行相应的操作
    },
    activexitong() {
      this.activeIndex = this.$store.getters.activexitong
    },
    menuList() {
      if (sessionStorage.getItem('navIndex') == '2') {
        this.Onclick(this.menuList[0], this.menuList[0].monitorId)
      }
    }
  },
  methods: {
    setNavIndex() {
      const path = this.$route.path;
      let index = -1;
      if (path === '/' || path === '/home') {
        index = 0;
      } else if (path.startsWith('/service')) {
        index = 1;
      } else if (path.startsWith('/AiZhi')) {
        index = 2;
      } else if (path.startsWith('/software')) {
        index = 3;
      } else if (path.startsWith('/companyintroduction')) {
        index = 4;
      } else if (path.startsWith('/newsinformation')) {
        index = 5;
      } else if (path.startsWith('/contactus')) {
        index = 6;
      }
      if (index !== -1) {
        this.navIndex = index;
        sessionStorage.setItem('navIndex', index);
      }
    },
    GoTop() {
      scrollToTop();
    },
    Onclick(e, x) {
      console.log(e, x)
      this.activeIndex = e.monitorId
      sessionStorage.setItem('navIndex', '2')
      this.$store.commit('increment', e);
      if (this.$route.path != '/AiZhi') {
        this.$router.replace({path: '/AiZhi'})
      }


    },
    async getList() {
      const res = await listMonitorTable({
        pageNum: 1,
        pageSize: 9999,
      })
      this.menuList = res.data.rows
      this.activeIndex = this.menuList[0].monitorId
      // this.Onclick(this.menuList[0], this.menuList[0].monitorId)
    },
    openUrl(e, x) {
      this.ziIndex = x
      this.$router.push({path: e.path})
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;

    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #ffffff;
  transition: all ease 0.6s;
  position: relative;
  z-index: 99;

}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {

  width: 440px;
  height: 100%;
  float: left;
  position: relative;
  display: flex;
  align-items: center;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {

  height: 80%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  //max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: rgba(10, 123, 252, 1);

}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  //transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: rgba(10, 123, 252, 1);
  text-decoration: none;

  border-bottom: 2px solid rgba(10, 123, 252, 1);
}

.activeChren {
  color: rgba(10, 123, 252, 1);
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}

.activeChren img {
  display: block !important;
}

#header .header-nav .header-nav-wrapper > li {
  //position: static; //z-index: 8;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 288px;
  top: 80%;
  z-index: 999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
  font-weight: 400 !important;
}

#header .header-nav .header-nav-wrapper > li:hover > dl {
  display: block;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  height: 40px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-bottom: 1px solid #ccc;
  //border-bottom: 1px solid #ccc; display: flex; align-items: center; justify-content: center;
}

#header .header-nav .header-nav-wrapper > li > dl > dt img {
  display: none;
}

#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block !important;

}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  //text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: none;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  font-weight: bold !important;
  //background: rgba(229, 229, 229, 0.8); display: flex; align-items: center; justify-content: center; color: rgba(10, 123, 252, 1);
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover img {
  display: block;

}

@media screen and (min-width: 765px) and (max-width: 1200px) {

  #header .header-nav .header-nav-logo img {
    width: 200px;
  }
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }


  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 150px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue